import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {GroupPricingsListFilter} from './GroupPricingsListFilter'

const GroupPricingsListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddGroupPricingModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-grouppricing-table-toolbar='base'>
      <GroupPricingsListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add grouppricing */}
      <button type='button' className='btn btn-primary' onClick={openAddGroupPricingModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='GROUPPRICING.TABLE.CREATEGROUPPRICING' defaultMessage={"Add GroupPricing"} />
      </button>
      {/* end::Add grouppricing */}
    </div>
  )
}

export {GroupPricingsListToolbar}
